import moment from 'moment';
import handlebars from 'handlebars';
import accounting from 'accounting';
import _ from 'underscore';

import DateUtilsService from 'services/dateUtilsService';

const dateUtilsService = new DateUtilsService();

handlebars.registerHelper('utcDateWithoutTime', function (eventDate) {
  if (!eventDate) return null;
  return dateUtilsService.toUTCMomentWithoutTime(eventDate).format('dddd, MMM DD YYYY');
});

handlebars.registerHelper('visitDate', function (eventDate) {
  return moment(eventDate).format('MMM D YYYY');
});

handlebars.registerHelper('bdayMonth', function (month) {
  return moment(month, 'MM').format('MMM');
});

handlebars.registerHelper('toFixed', function (num) {
  return num.toFixed(2);
});

handlebars.registerHelper('lowercase', function (str) {
  if (str && typeof str === 'string') {
    return str.toLowerCase();
  }
  return '';
});

handlebars.registerHelper('guestType', function (guest) {
  if (guest.type === 'TABLE' || guest.type === 'PACKAGE') {
    return 'TABLE: ';
  } else if (guest.type === 'TICKET') {
    return 'TICKETS: ';
  }
  return 'Guestlist: ';
});

handlebars.registerHelper('guestTypeIcon', function (guest) {
  if (guest.type === 'TABLE' || guest.type === 'PACKAGE') {
    return 'ion-grid';
  } else if (guest.type === 'TICKET') {
    return 'ion-qr-scanner';
  }
  return 'ion-clipboard';
});

handlebars.registerHelper('guestTypeLink', function (guest) {
  if (guest.type === 'TABLE' || guest.type === 'PACKAGE') {
    return 'event-reservations-list';
  }
  return 'event-guests';
});

//Moment Helpers
handlebars.registerHelper('numberAmount', function (num) {
  return num || 0;
});

handlebars.registerHelper('toUpperCase', function (text) {
  if (!text) return '';
  return text.toUpperCase();
});

handlebars.registerHelper('printDate', function (date) {
  return moment(date).format('dddd MM/DD/YY');
});

handlebars.registerHelper('humanDate', function (date) {
  return moment(date).format('dddd, MMM DD YYYY');
});

handlebars.registerHelper('addedDate', function (date) {
  return moment(date).format('MMMM Do, h:mm a');
});

handlebars.registerHelper('shortDate', function (date) {
  return moment(date).format('MM/DD/YY');
});

handlebars.registerHelper('log', function (something) {
  console.log(something);
});

handlebars.registerHelper('shortDateWithDay', function (date) {
  return moment(date).format('ddd MM/DD/YY');
});

handlebars.registerHelper('timeAgo', function (date) {
  return moment(date).fromNow();
});

handlebars.registerHelper('reservationTime', function (date) {
  return moment(date).format('ddd, MMM Do h:mm A');
});

handlebars.registerHelper('checkedInTime', function (date) {
  return moment(date).format('h:mm A');
});

handlebars.registerHelper('arrivalTime', function (date) {
  return moment.utc(date).format('h:mm A');
});

handlebars.registerHelper('calculateTicketRevenue', function (ticket) {
  return ticket.price * ticket.quantitySold;
});

handlebars.registerHelper('labelType', function (type) {
  let label = '';

  if (type === 'TABLE' || type === 'PACKAGE') {
    label = 'label-success';
  } else {
    label = 'label-primary';
  }
  return label;
});

handlebars.registerHelper('formatMin', function (min) {
  if (!min) return '';
  return `$${min}`;
});

handlebars.registerHelper('minText', function (min) {
  let theMinimum = min || 0;

  if (parseFloat(theMinimum) > 50) {
    theMinimum = `$${theMinimum} Minimum`;
  }

  if (parseFloat(theMinimum) <= 50) {
    theMinimum += ' Bottle Minimum.';
  }

  if (parseFloat(theMinimum) === 0) {
    theMinimum = 'No Minimum. ';
  }

  return theMinimum;
});

handlebars.registerHelper('formatTables', function (tables) {
  if (!tables || !tables.length) return '';

  let tableStr = '';
  _.each(tables, (table, i) => {
    tableStr += table.name;

    if (i < tables.length - 1) tableStr += ',';
  });

  return tableStr;
});

handlebars.registerHelper('formatReceipts', function (receipts) {
  if (!receipts || !receipts.length) return '';

  let str = '';
  _.each(receipts, (receipt, i) => {
    str += receipt.name;

    if (i < receipts.length - 1) str += ',';
  });

  return str;
});

handlebars.registerHelper('currency', function (min) {
  let theSpend = min || 0;

  if (parseFloat(theSpend) > 0) {
    theSpend = `$${theSpend}`;
  } else {
    theSpend = '$0';
  }

  return theSpend;
});

handlebars.registerHelper('formatMoney', function (min) {
  let theSpend = min || 0;

  theSpend = accounting.formatMoney(theSpend);

  return theSpend;
});

handlebars.registerHelper('calculatePayment', function (spend, percent, customPercent) {
  const theSpend = spend || 0;

  let comission = customPercent || percent;

  if (!comission) comission = 0;

  const payment = accounting.formatMoney(theSpend * comission / 100);

  return payment;
});

handlebars.registerHelper('eventWeekDay', function (eventDate) {
  return moment(eventDate).format('ddd');
});

handlebars.registerHelper('eventDay', function (eventDate) {
  return moment(eventDate).format('D');
});

handlebars.registerHelper('eventMonth', function (eventDate) {
  return moment(eventDate).format('MMM');
});



// WEBPACK FOOTER //
// ./src/handlebarsHelpers.js